import React from "react";
import { renderToString } from "react-dom/server";
import { PinSvg } from "./PinSvg";

export type AirportMapPinType = {
  type: "airport";
}

export const getAirportMapPin = () => {
  const element = document.createElement("div");
  element.innerHTML = renderToString(<AirportPin />);
  return element;
}

export const AirportPin = () => {
  return <div className="google-map-pin-wrapper">
    <PinSvg width={27} height={43} empty fillColor="var(--map-airport-green)" />
  </div>
}